import { useEffect, useState } from "react";
import type { AdminRunnerList, AdminRunnerRow } from "@paceroo/domain/views/admin";
import { adminGet } from "../lib/api";

/** Up to `limit` runners matching q (email, name or exact id), debounced. */
export function useRunnerSearch(q: string, limit = 6): { results: AdminRunnerRow[]; searching: boolean } {
  const [state, setState] = useState<{ q: string; results: AdminRunnerRow[] }>({ q: "", results: [] });
  const query = q.trim();
  useEffect(() => {
    if (!query) return;
    const ctl = new AbortController();
    const t = window.setTimeout(() => {
      adminGet<AdminRunnerList>(`runners?q=${encodeURIComponent(query)}&per=${limit}&sort=seen`, ctl.signal).then(
        (list) => setState({ q: query, results: list.rows }),
        () => {
          if (!ctl.signal.aborted) setState({ q: query, results: [] });
        },
      );
    }, 150);
    return () => {
      ctl.abort();
      window.clearTimeout(t);
    };
  }, [query, limit]);
  if (!query) return { results: [], searching: false };
  return { results: state.q === query ? state.results : [], searching: state.q !== query };
}
